// NPM
import React, { useState, useEffect } from "react";
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// Services
import apiService from "services/apiService";
import renderService from 'services/renderService';

function ElectionOutcome() {
  // State
  const [seatShareData, setSeatShareData] = useState({});
  const campaignConfig = useSelector(state => state.campaignConfig.value);
  const region = useSelector(state => state.region.value);
  const parties = useSelector(state => state.parties.value);
  const partyIds = parties.map(p => p.id);

  const loadData = async () => {
    const response = await fetch(apiService.apiURL("seat_share"));
    const jsonData = await response.json();
    setSeatShareData(jsonData);
  }

  // Hooks
  useEffect(() => loadData(), []);

  // Short-circuit
  if(!renderService.canRender([seatShareData, region, parties])) {
    return null;
  }

  // Make sure we're only rendering data that can be matched to a party
  const filteredSeatShareData = _
    .chain(seatShareData)
    .filter(ssd => _.includes(partyIds, ssd.party))
    .filter(ssd => ssd.region === region)
    .sortBy(ssd => parseInt(ssd.median))
    .reverse()
    .value()

  const mostSeatData = filteredSeatShareData[0];
  const mostSeatParty = parties.find(p => p.id === mostSeatData.party);

  const { title, description } = _.get(campaignConfig, `sections.ElectionOutcome`, {});
  
  const modifiedTitle = title.replace(
    "{{PARTY_NAME}}", 
    `<span class="ElectionOutcome__party" style="border-bottom-color: ${ mostSeatParty.color }80;">${mostSeatParty.friendlyName}</span>`
  );

  return (
    <div className="ElectionOutcome">
      <p className="ElectionOutcome__description">
        { description }
      </p>
      
      <h2 
        className="ElectionOutcome__title"
        dangerouslySetInnerHTML={ {__html: modifiedTitle} }
      />
    </div>
  )
}

export default ElectionOutcome;